//Merge integrations
import coachSSO from '../../coachSSO/lan/es';

const locales = {
  ...coachSSO,
};

export default locales;
